import React, { useEffect, useState } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { faArrowRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  assignPresentation,
  fetchSpeakers,
} from "../../redux/features/presentations/presentationsSlice";
import { toast } from "react-toastify";

function AssignPresentation() {
  const { uuid } = useParams();
  const dispatch = useDispatch();

  const { speakers, getSpeakersLoading, AssignPresetationLoading } =
    useSelector((state) => state.presentation);

  const [selectedSpeakers, setSelectedSpeakers] = useState([]);

  useEffect(() => {
    dispatch(fetchSpeakers(uuid));
  }, [dispatch]);
  

  const handleToggle = (speakerId) => {
    setSelectedSpeakers((prev) =>
      prev.includes(speakerId)
        ? prev.filter((id) => id !== speakerId)
        : [...prev, speakerId],
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (selectedSpeakers.length === 0) {
      toast.error("Please select at least one speaker");
      return;
    }

    try {
      const formData = new FormData();

      selectedSpeakers.forEach((id, index) => {
        formData.append(`admin_id[${index}]`, id);
      });

      await dispatch(
        assignPresentation({ speakersIds: formData, presentationId: uuid }),
      ).unwrap();

      toast.success("Assigned Successfully!");
    } catch (error) {
      toast.error(error.message || error || "Assignment failed");
    }
  };

  return (
    <div className="min-h-screen bg-lightPurple/5 flex flex-col">
      <Navbar />
      <div className="flex-grow max-w-[70vw] w-full mx-auto px-4 pt-8">
        <Link to="/presentations">
          <button className="p-2 text-sm rounded-lg bg-purple-400 hover:bg-purple-500 text-white font-bold w-24 uppercase">
            <FontAwesomeIcon icon={faArrowRotateLeft} className="mr-1" />
            Back
          </button>
        </Link>

        <div className="my-8 text-center">
          <h1 className="text-3xl font-semibold text-gray-800">
            Assign Presentation
          </h1>
          <p className="text-gray-500 mt-1 capitalize">
            Select speakers to assign them to this presentation
          </p>
        </div>

        <div className="bg-white shadow-lg rounded-2xl p-6 h-full max-h-[40vw] overflow-y-auto">
          <h2 className="text-2xl text-center uppercase font-semibold mb-8 text-lightPurple">
            Speakers List
          </h2>

          {getSpeakersLoading ? (
            <p className="text-center text-gray-500">Loading speakers...</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {speakers.map((speaker) => (
                <label
                  key={speaker.id}
                  className="flex items-center gap-4 p-3 border rounded-xl hover:bg-gray-50 cursor-pointer transition"
                >
                  <input
                    type="checkbox"
                    checked={selectedSpeakers.includes(speaker.id) || speaker.assigned_to_presentation}
                    onChange={() => handleToggle(speaker.id)}
                    className="w-5 h-5 accent-purple-500"
                  />
                  <span className="text-gray-700 font-medium">
                    {speaker.name}
                  </span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className="mt-8 flex justify-end">
          <button
            onClick={handleSave}
            disabled={AssignPresetationLoading}
            className={`px-6 py-3 rounded-xl shadow-md text-white transition ${
              AssignPresetationLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-lightPurple hover:bg-purpleColor"
            }`}
          >
            {AssignPresetationLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default AssignPresentation;
